import styled from '@emotion/styled'
import CheckboxField from '../CheckboxField'
import { getBodyFonts } from 'css/theme'
import { forwardRef } from 'react'
import { useTranslation } from 'next-i18next'
import useConfig from 'modules/config/state/use-config'

interface WaiverFieldProps {
  id: string | number
  label: string
  error?: { message: string }
  maxLength?: number
  required: boolean
  value?: string
  dataId?: string
  autoFocus?: boolean
  onFocus?: () => void
}

const WaiverField = forwardRef<HTMLInputElement, WaiverFieldProps>(
  ({ id, label, error, required, dataId, autoFocus, onFocus }, ref) => {
    const { t } = useTranslation('common')
    const config = useConfig()

    return (
      <WaiverWrapper isEmbedded={config.isEmbedded}>
        <WaiverLabel>{label}</WaiverLabel>
        <CheckboxField
          id={`${id}`}
          error={error}
          required={required}
          dataId={dataId}
          ref={ref}
          autoFocus={autoFocus}
          onFocus={onFocus}
        >
          {t('WaiverField.agreementCheckbox.label', 'I accept the waiver agreement')}
        </CheckboxField>
      </WaiverWrapper>
    )
  },
)

WaiverField.displayName = 'WaiverField'

export default WaiverField

const WaiverWrapper = styled.div<{ isEmbedded: boolean }>`
  ${({ isEmbedded }) => !isEmbedded && 'margin-top: 2rem;'}
`

const WaiverLabel = styled.div({
  maxHeight: '340px',
  overflowY: 'auto',
  width: '100%',
  borderRadius: 8,
  marginBottom: 8,
  padding: '8px 12px',
  border: '1px #857f7a solid',
  ...getBodyFonts(),
})
